module.exports = __webpack_public_path__ + "static/media/instructor2.6e0007f4.png";